document.addEventListener('DOMContentLoaded', () => {
    const navContainer = document.querySelector('.custom-navigation__container');
    const overlay = document.querySelector('.custom-navigation__overlay');
    const closeMobile = document.querySelector('.custom-navigation__header-close');

    const hideAllLevels = (selector, openClass) => {
        document.querySelectorAll(selector).forEach(level => {
            level.style.opacity = 0;
            level.classList.remove('visible');
            if (openClass) {
                level.closest('.' + openClass)?.classList.remove(openClass);
            }
        });
    };

    const clearActiveLinks = (selector, activeClass) => {
        document.querySelectorAll(selector).forEach(link => {
            link.classList.remove(activeClass);
        });
    };

    const showOverlay = () => {
        overlay.classList.add('visible');
    };

    const hideOverlay = () => {
        overlay.classList.remove('visible');
    };

    const cartSummary = document.querySelector(".cart__summary");
    let screenWidth = window.innerWidth;

    const navOpener = document.querySelector('.header__navigation-opener');
    if (navOpener) {
        navOpener.addEventListener('click', () => {
            navContainer.classList.add('visible');
            if (cartSummary && screenWidth <= 987) {
                cartSummary.style.zIndex = 1;
            }
            showOverlay();
            toggleBodyOverflow(true);
        });
    }

    if (overlay) {
        overlay.addEventListener('click', () => {
            hideAllLevels('.custom-navigation__second-level', 'custom-navigation__first-level--open');
            hideAllLevels('.custom-navigation__third-level', 'custom-navigation__second-level--open');
            clearActiveLinks('.custom-navigation__first-level-link', 'active');
            clearActiveLinks('.custom-navigation__second-level-link', 'active');
            navContainer.classList.remove('visible');
            hideOverlay();
            toggleBodyOverflow(false);
        });
    }

    if (closeMobile) {
        closeMobile.addEventListener('click', () => {
            hideAllLevels('.custom-navigation__second-level', 'custom-navigation__first-level--open');
            hideAllLevels('.custom-navigation__third-level', 'custom-navigation__second-level--open');
            clearActiveLinks('.custom-navigation__first-level-link', 'active');
            clearActiveLinks('.custom-navigation__second-level-link', 'active');
            navContainer.classList.remove('visible');
            hideOverlay();

            if (cartSummary && screenWidth <= 987) {
                cartSummary.style.zIndex = 801;
            }
            toggleBodyOverflow(false);
        });
    }

    document.querySelectorAll('.custom-navigation__first-level--openable .custom-navigation__first-level-link').forEach(link => {
        link.addEventListener('click', (event) => {
            event.preventDefault();
            const parent = link.closest('.custom-navigation__first-level--openable');
            const secondLevel = parent.querySelector('.custom-navigation__second-level');
            if (secondLevel) {
                hideAllLevels('.custom-navigation__second-level', 'custom-navigation__first-level--open');
                hideAllLevels('.custom-navigation__third-level', 'custom-navigation__second-level--open');
                clearActiveLinks('.custom-navigation__first-level-link', 'active');
                clearActiveLinks('.custom-navigation__second-level-link', 'active');
                if (secondLevel.style.opacity === 1) {
                    secondLevel.classList.remove('visible');
                    parent.classList.remove('custom-navigation__first-level--open');
                } else {
                    secondLevel.classList.add('visible');
                    parent.classList.add('custom-navigation__first-level--open');
                    link.classList.add('active');
                }
            }
        });
    });

    document.querySelectorAll('.custom-navigation__second-level--openable .custom-navigation__second-level-link').forEach(link => {
        link.addEventListener('click', (event) => {
            event.preventDefault();
            const parent = link.closest('.custom-navigation__second-level--openable');
            const thirdLevel = parent.querySelector('.custom-navigation__third-level');
            const navLevel1 = document.querySelector('.custom-navigation__level-1'); 
    
            if (thirdLevel) {
                const isVisible = thirdLevel.classList.contains('visible');
                const thirdLevelMedia = thirdLevel.querySelector('.custom-navigation__third-level_media');
    
                hideAllLevels('.custom-navigation__third-level', 'custom-navigation__second-level--open');
                clearActiveLinks('.custom-navigation__second-level-link', 'active');
    
                // Pulizia classi prima
                navLevel1.classList.remove('large', 'medium');
    
                if (isVisible) {
                    // Stava aperto: lo chiudo
                    thirdLevel.classList.remove('visible');
                    parent.classList.remove('custom-navigation__second-level--open');
                } else {
                    // Lo apro
                    thirdLevel.classList.add('visible');
                    parent.classList.add('custom-navigation__second-level--open');
                    link.classList.add('active');
    
                    if (thirdLevelMedia) {
                        navLevel1.classList.add('large');
                        console.log('large aggiunta');
                    } else {
                        navLevel1.classList.add('medium');
                        console.log('medium aggiunta');
                    }
                }
            }
        });
    });     

    document.querySelectorAll('.custom-navigation__back').forEach(backButton => {
        backButton.addEventListener('click', (event) => {
            event.preventDefault();
            const level = backButton.closest('.custom-navigation__second-level, .custom-navigation__third-level');
            const navLevel1 = document.querySelector('.custom-navigation__level-1'); 
            if (level) {
                level.style.opacity = 0;
                level.classList.remove('visible');
                const parentOpenable = level.closest('.custom-navigation__first-level--openable, .custom-navigation__second-level--openable');
                parentOpenable?.classList.remove('custom-navigation__first-level--open', 'custom-navigation__second-level--open');
                clearActiveLinks('.custom-navigation__first-level-link', 'active');
                clearActiveLinks('.custom-navigation__second-level-link', 'active');
    
                if (level.classList.contains('custom-navigation__second-level')) {
                    hideAllLevels('.custom-navigation__third-level', 'custom-navigation__second-level--open');
                }
    
                if (!document.querySelector('.custom-navigation__third-level.visible')) {
                    navLevel1.classList.remove('large');
                }
            }
        });
    });
    

    document.querySelectorAll('.custom-navigation__second-level-content').forEach(content => {
        const firstMacroElement = content.querySelector('.custom-navigation__second-level-macro');
        if (firstMacroElement) {
            firstMacroElement.style.paddingTop = '12px';
        }
        content.querySelectorAll('.custom-navigation__third-level-content').forEach(thirdContent => {
            const firstThirdMacroElement = thirdContent.querySelector('.custom-navigation__third-level-macro');
            if (firstThirdMacroElement) {
                firstThirdMacroElement.style.paddingTop = '12px';
            }
        });
    });
});

function toggleBodyOverflow(hide) {
    if (hide) {
        document.documentElement.style.overflow = "hidden";
        document.body.style.overflow = "hidden";
    } else {
        document.documentElement.style.overflow = "";
        document.body.style.overflow = "";
    }
}

function updateMediaWidth() {
    if (window.innerWidth > 1240) {
        const card = document.querySelector('.custom-navigation__third-level-card');
        const media = document.querySelector('.custom-navigation__third-level_media');
    
        if (card && media) {
            const cardHeight = card.offsetHeight;
            const aspectRatio = 375 / 511;
            const newWidth = cardHeight * aspectRatio;
            
            // media.style.width = `${newWidth}px`;
        }
    }
}

window.addEventListener('load', updateMediaWidth);
window.addEventListener('resize', updateMediaWidth);
  